<div class="msTeam-modalBody clearfix dBlock" *ngIf="isLoggedIn&&!isSettings" style="width: 100%">
  <div class="msTeam-modalBodyTop" style="padding-left: 10px; padding-right: 10px;">
    <!-- upload file view-->
    <div class="single-file" *ngIf="isUpload && !isUploadScreen">
      <img src="./assets/{{getFileIcon()}}_icon.svg" width="35" alt="file" style="padding-right:10px;">
      <div class="full-width overflowHidden">
        <h4 class="name">
          {{ file?.name}}
        </h4>
        <p class="size">
          {{ formatBytes(file?.size) }}
        </p>
      </div>
    </div>
    <!-- upload file view end -->
    <div *ngIf="isUpload && !isUploadScreen" class="uploaddesc">{{uploadDescText}}</div>


    <nav mat-tab-nav-bar *ngIf="!isUpload && !isUploadScreen && !isShare">
      <a mat-tab-link *ngFor="let link of navLinks;let i = index;" routerLink="{{link.link}}" routerLinkActive
         #rla="routerLinkActive" [active]="activeLinkIndex === i" (click)="menuClick(i)">
        <span id="{{link.label}}">{{ link.label}}</span>
      </a>
    </nav>
    <div *ngIf="!isShare">
      <!-- <mat-form-field [ngClass]="(activeLinkIndex==0||activeLinkIndex==2)&&!insideFolderfiles ? 'full-width-field-search-filter-only' : 'full-width-field-search'" floatLabel="never" *ngIf="!isUploadScreen" style="margin-bottom: -14px;" -->
      <mat-form-field class="full-width-field-search" floatLabel="never" *ngIf="!isUploadScreen" style="margin-bottom: -14px;">
        <!-- <input matInput [(ngModel)]="searchText" (ngModelChange)="onChange($event)" placeholder="Search"
          autocomplete="off" />
        <button mat-button mat-icon-button matSuffix (click)="clearSearchField()" *ngIf="searchText">
          <mat-icon>close</mat-icon>
        </button> -->
        <!-- </mat-form-field> -->
        <button class="iconbutton" *ngIf="searchText" matTooltip="Remove search text" [matTooltipPosition]="position.value" mat-button matSuffix
                aria-label="Remove search text" (click)="clearSearchField()">
          <div class="closeIcon" width="22px" alt="Remove search text"></div>
        </button>
        <button class="iconbutton" *ngIf="(activeLinkIndex!=0||(insideFolderfiles && !isUpload))&&!isLoading" matTooltip="Filter" [matTooltipPosition]="position.value" mat-button matSuffix
                [matMenuTriggerFor]="menuFilter" aria-label="filter" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
          <!-- <mat-icon>filter_list</mat-icon> -->
          <div class="filterIcon" width="24px" alt="filter"></div>
        </button>
        <mat-menu #menuFilter="matMenu">
          <button mat-menu-item (click)="setActiveItemFilter('All')" [ngClass]="activeItemFilter==='All' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemFilter == 'All') ? 'Show all, selected ': 'Show all'">
            Show all
          </button>
          <button *ngIf="activeLinkIndex==2&&!insideFolderfiles" mat-menu-item (click)="setActiveItemFilter('Sites')" [ngClass]="activeItemFilter==='Sites' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemFilter == 'Sites') ? 'Sites, selected ': 'Sites'">
            Sites
          </button>
          <button mat-menu-item (click)="setActiveItemFilter('Folders')" [ngClass]="activeItemFilter==='Folders' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemFilter == 'Folders') ? 'Folders, selected ': 'Folders'">
            Folders
          </button>
          <button mat-menu-item (click)="setActiveItemFilter('Files')" [ngClass]="activeItemFilter==='Files' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemFilter == 'Files') ? 'Files, selected ': 'Files'">
            Files
          </button>
        </mat-menu>

        <button class="iconbutton" *ngIf="(activeLinkIndex==0 ||activeLinkIndex==2||insideFolderfiles)&&!isLoading" matTooltip="Sort" [matTooltipPosition]="position.value" mat-button matSuffix
                [matMenuTriggerFor]="menuSort" aria-label="sort" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
          <!-- <mat-icon>sort</mat-icon> -->
          <div class="sortIcon" alt="sort"></div>
        </button>

        <mat-menu #menuSort="matMenu">
          <button mat-menu-item (click)="setActiveItemSort('nameaz')" [ngClass]="activeItemSort==='nameaz' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'nameaz') ? 'By name (A - Z), selected ': 'By name (A - Z)'">
            By name (A - Z)
          </button>
          <button mat-menu-item (click)="setActiveItemSort('nameza')" [ngClass]="activeItemSort==='nameza' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'nameza') ? 'By name (Z - A), selected ': 'By name (Z - A)'">
            By name (Z - A)
          </button>

          <button *ngIf="activeLinkIndex==2 || insideFolderfiles" mat-menu-item (click)="setActiveItemSort('dateoldnew')" [ngClass]="activeItemSort==='dateoldnew' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'dateoldnew') ? 'By date (old - new), selected ': 'By date (old - new)'">
            By date (old - new)
          </button>
          <button *ngIf="activeLinkIndex==2 || insideFolderfiles" mat-menu-item (click)="setActiveItemSort('datenewold')" [ngClass]="activeItemSort==='datenewold' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'datenewold') ? 'By date (new - old), selected ': 'By date (new - old)'">
            By date (new - old)
          </button>
          <button *ngIf="(activeLinkIndex==2 || insideFolderfiles) && !isUpload" mat-menu-item (click)="setActiveItemSort('sizesl')" [ngClass]="activeItemSort==='sizesl' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'sizesl') ? 'By size (small - large), selected ': 'By size (small - large)'">
            By size (small - large)
          </button>
          <button *ngIf="(activeLinkIndex==2 || insideFolderfiles) && !isUpload" mat-menu-item (click)="setActiveItemSort('sizels')" [ngClass]="activeItemSort==='sizels' ? 'menuSelected' : 'menuNotSelected'" [attr.aria-label]="(activeItemSort == 'sizels') ? 'By size (large - small), selected ': 'By size (large - small)'">
            By size (large - small)
          </button>
        </mat-menu>
        <input matInput [(ngModel)]="searchText" (ngModelChange)="onChange($event)" aria-label="Search"
               autocomplete="off" [disabled]="disabled">
        <mat-placeholder class="placeholder">Search</mat-placeholder>
        <!-- <button mat-button mat-icon-button matSuffix (click)="clearSearchField()" *ngIf="searchText">
          <img matTooltip="Remove search text" src="./assets/close_black_icon.svg" width="24px" alt="Remove search text">
        </button> -->
        <!-- <button *ngIf="searchText" matTooltip="Remove search text" mat-button matSuffix
          aria-label="Remove search text" (click)="clearSearchField()">
          <img src="./assets/close_black_icon.svg" width="22px" alt="Remove search text">
        </button> -->
      </mat-form-field>
    </div>

    <div class="breadcrump-split" *ngIf="insideFolderfiles && !isShare && !isUploadScreen">
      <span style="margin-left: -5px !important;display: inline-block" *ngFor="let m of menuHeader; let indx = index">
        <div *ngIf="indx!=menuHeader.length-1|| menuHeader.length==1">
          <a mat-button (keyup.enter)="breadCrumb(menuHeader, indx)" (click)="breadCrumb(menuHeader, indx)" [attr.aria-label]="'Move back to ' + menuHeader[indx]['label']" class="breadcrumbtxt">
            {{m.label}}
            <div class="arrowIconSimple" width="10px" height="10px" alt="rightarrow"></div>
          </a>
        </div>

        <span *ngIf="indx==menuHeader.length-1 && menuHeader.length!=1" style="padding: 0 5px !important" class="breadcrumbtxt">
          {{m.label}}
          <div class="arrowIconSimple2" width="10px" height="10px" alt="rightarrow"></div>
        </span>
      </span>
      <!-- <ul style="margin-left: -5px !important;display: inline-block" class="breadcrumbs" *ngFor="let m of menuHeader;let indx = index">
          <a mat-button (keyup.enter)="breadCrumb(menuHeader, indx)" (click)="breadCrumb(menuHeader, indx)" aria-label="Move back to menuHeader[indx][label]">
            {{m.label}}
            <img src="./assets/right_arrow.svg" width="10px" height="10px" alt="rightarrow">
          </a>
      </ul>   -->
      <!-- <ul >
        <li class="breadcrumbs" *ngFor="let m of menuHeader"><a mat-button (keyup.enter)="breadCrumb(menuHeader, indx)" (click)="breadCrumb(menuHeader, indx)" >{{m.label}}</a></li> -->
      <!-- <li >{{m.label}}</li> -->
      <!--  <li><a>Long item</a></li>
        <li><a>Really long item</a></li>
        <li><a>Really, really long item</a></li>
        <li><a>Long item</a></li>-->
      <!-- </ul> -->
    </div>
  </div>
</div>
